import React from "react";

import {
  graphDatesSelector,
  graphParamsSelector,
  graphEntriesSelector,
  intervalSelector,
  idSelector,
  talkersSelector,
  titleSelector,
  threatsSelector,
} from "../../../selectors/ipSelectors";
import {
  fetchGraph,
  fetchTalkers,
  fetchThreats,
  receiveDateRange,
  redirectToIndex,
} from "../../../redux/actions/Ip";
import Detail from "./common/Detail";

/*
Component
*/

const IpDetail = () => (
  <Detail
    detailErrorMsgSelector={() => []}
    fetchTalkers={fetchTalkers}
    fetchThreats={fetchThreats}
    fetchWindowsEvts={() => () => {}}
    fetchGraph={fetchGraph}
    graphDatesSelector={graphDatesSelector}
    graphEntriesSelector={graphEntriesSelector}
    graphParamsSelector={graphParamsSelector}
    idSelector={idSelector}
    intervalSelector={intervalSelector}
    receiveDateRange={receiveDateRange}
    redirectToIndex={redirectToIndex}
    talkersSelector={talkersSelector}
    threatsSelector={threatsSelector}
    titleSelector={titleSelector}
    windowsEvtsSelector={() => []}
  />
);

export default IpDetail;
